import { FEATURES } from "../../utils/featureAccess";

export const NAV_ITEMS = [
  {
    to: "/fleet",
    label: "Fleet",
    iconName: "Gauge",
    featureId: null,
  },
  {
    to: "/stations",
    label: "Stations",
    iconName: "Building2",
    featureId: null,
  },
  {
    to: "/chargers",
    label: "Charger Summary",
    iconName: "PlugZap",
    featureId: null,
  },
  {
    to: "/admin",
    label: "Admin",
    iconName: "ShieldCheck",
    featureId: FEATURES.USER_MANAGEMENT,
  },
];

export const SIDEBAR_WIDTH_EXPANDED = 200;
export const SIDEBAR_WIDTH_COLLAPSED = 64;
